// Automatically determine whether to use Black or White as the foreground colour.
// Hopefully matches what Google do... 
const contrastColor = ({
  bgColor = '#FFFFFF',
  fgDarkColor = '#000000',
  fgLightColor = '#FFFFFF',
  defaultColor = '#000000',
  threshold = 128,
} = {}) => {
  const hexChars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F']

  let bgColorArray = String(bgColor)
    .toUpperCase()
    .split('')
    .filter(c => hexChars.includes(c))

  switch (bgColorArray.length) {
    case 3:
    case 4:
      bgColorArray = bgColorArray.slice(0, 3).map(c => `${c}${c}`)
      break
    case 6:
    case 8:
      bgColorArray = bgColorArray
        .slice(0, 6)
        .reduce((acc, curr, n, arr) => n % 2 ? [...acc, `${arr[n - 1]}${curr}`] : acc, [])
      break
    default:
      return defaultColor
  }

  const [r, g, b] = bgColorArray.map(h => parseInt(h, 16))
  const yiq = (r * 299 + g * 587 + b * 114) / 1000

  return yiq >= threshold ? fgDarkColor : fgLightColor
}

export {
  contrastColor
}